function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", null, ".st35{fill:#b154a0}");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "st35",
  d: "M15.4 12.6c-2.1 1.7-5.2 1.4-7-.7s-1.4-5.2.7-7 6.4-1.3 8.2.8.3 5.2-1.9 6.9z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "st35",
  d: "M16.5 6.1c.6-1.3 1.2-2.7 2.1-3.8.9-1.1 2.2-2.1 3.6-2.3-.6 1.1-1.2 2.4-.8 3.6.5 1.7 2.5 2.4 3.3 4 0 .1.1.2 0 .2 0 .2-.2.2-.3.2-2.8.3-5.6-.2-8-1.5M9 10.8c-.5 1.4-1 2.7-1.9 3.9S5 16.9 3.5 17.1c.5-1.1 1-2.4.5-3.6-.7-1.6-3-2.3-3.9-3.8-.1-.1-.1-.2-.1-.2 0-.1.2-.2.3-.2 2.9-.5 6 0 8.8 1.2"
});

var _ref5 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "SVGID_9_",
  d: "M15.4 12.6c-2.1 1.7-5.2 1.4-7-.7s-1.4-5.2.7-7 6.4-1.3 8.2.8.3 5.2-1.9 6.9z"
}));

var _ref6 =
/*#__PURE__*/
React.createElement("clipPath", {
  id: "SVGID_2_"
}, React.createElement("use", {
  xlinkHref: "#SVGID_9_",
  overflow: "visible"
}));

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  clipPath: "url(#SVGID_2_)",
  fill: "#c881b7",
  d: "M19.3 9.9l-3.6 2.6L6.9 7l3-2.6z"
});

var SvgCandy = function SvgCandy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 24.7 17.1",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCandy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/candy.16e09acb.svg";
export { ForwardRef as ReactComponent };